<template>
  <div class="component" id="GuideImage" ref="GuideImage">
    <div class="image-box">
      <van-image :class="{error: imageLoaderror}" :src="image" @error="showError()" class="image" />
      <div @click="showDetailImage()" class="trigger" v-if="!imageLoaderror"></div>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import { Image, ImagePreview } from "vant";
  Vue.use(Image).use(ImagePreview);
  export default {
    name: "GuideImage",
    filters: {},
    props: {
      image: String,
      detailImage: String,
    },
    data() {
      return {
        imageLoaderror: false,
        activeNames: ["1"],
      };
    },
    computed: {
      showRemark: function () {
        return this.activeNames.includes("1");
      },
    },
    watch: {},
    mounted() {
      // let that = this;
    },
    methods: {
      showDetailImage() {
        let that = this;
        ImagePreview({
          images: [that.detailImage],
          closeable: true,
          showIndex: false,
          maxZoom: 5,
          minZoom: 1 / 3,
        });
      },
      showError() {
        this.imageLoaderror = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import "../main";
  #GuideImage.component {
    .image-box {
      #bundle.flex-row();
      justify-content: center;
      font-size: 0;
      position: relative;
      .image {
        width: 100%;
        height: auto;
        &.error {
          min-height: calc(100vh - @nav-height);
        }
      }
      .trigger {
        // background: #ff0000;
        opacity: 0;
        position: absolute;
        top: 65px;
        width: 350px;
        height: 200px;
      }
    }
  }
</style>